let activePopup = null;

var PopUp = function (title = '', size = 'full', position = 'default', name = '', sourceId = '') {

    this.title = title;
    this.size = size;
    this.position = position;
    this.name = name;
    this.sourceId = sourceId;  // Store the sourceId in the instance

    // Reset modal dialog styles before applying new ones
    $('#builderModal .modal-dialog').removeAttr('style');
    $('#builderModal .modal-dialog').removeClass(function (index, className) {
        return (className.match(/modal-size-[a-zA-Z0-9_\-]+/g) || []).join(' ');
    });
    $('#builderModal').removeClass('content-width');
    $('#builderModal .modal-dialog').removeClass('login-styles');

    // Reset specific styles applied in previous initializations
    $('#builderModal .modal-body').removeAttr('style');
    $('#builderModal .PopUpContent').removeAttr('style');
    $('#builderModal .modal-dialog .modal-content').removeAttr('style');
    $('#builderModal .modal-dialog .modal-content .modal-header').removeAttr('style');
    $('#builderModal .modal-header .close').removeAttr('style');

    // Determine screen dimensions and apply the appropriate styles
    const screenHeight = $(window).height();
    let maxHeight;
    let paddingleftright;

    // Apply the new size and position
    if (size === 'auto' && position === 'default') {
        $('#builderModal .modal-dialog').addClass('modal-size-default');
        $('#builderModal .modal-dialog').css('max-width', 'none');
        $('.PopUpContent').css('height', 'auto');
        $('#builderModal .default-popup').show();
        $('#builderModal .right-popup').hide();
    } else if (size === 'xright' && position === 'right') {
        $('#builderModal .modal-dialog').addClass('modal-size-xright');
        $('#builderModal .modal-dialog').css('max-width', 'none');
        $('#builderModal').addClass('content-width');
        $('#builderModal .default-popup').hide();
        $('#builderModal .right-popup').show();
    } else if (size === 'small') {
        $('#builderModal .modal-dialog').addClass('modal-size-small');
        $('#builderModal .modal-dialog').css('max-width', '650px');
        $('.PopUpContent').css('height', 'auto');
        $('#builderModal .default-popup').show();
        $('#builderModal .right-popup').hide();
    } else if (size === 'midsize') {
        $('#builderModal .modal-dialog').addClass('modal-size-small');
         $('.default-popup').addClass('modal-dialog-centered');

        // Set max height based on screen size
        if (screenHeight > 768) { // Assuming a desktop breakpoint at 768px
            maxHeight = screenHeight - 200;
            paddingleftright = 20;
        } else {
            maxHeight = screenHeight - 80;
            paddingleftright = 0;
        }

        $('#builderModal .modal-dialog').css({
            'max-width': '800px',
            'max-height': maxHeight + 'px',
            'border-radius': '20px',
            'overflow': 'none' // Enable scrolling if content overflows
        });
        $('#builderModal .modal-content').css({
            'max-height': (maxHeight - 60) + 'px',
            'overflow-y': 'auto' // Enable scrolling if content overflows
        });
        $('#builderModal .modal-body').css({
            'padding-left': paddingleftright + 'px',
            'padding-right': paddingleftright + 'px',
            'padding-top': '0px',
            'padding-bottom': '0px',
        });
        $('#builderModal .PopUpContent').css({
            'margin': '20px 0px',
        });
        $('#builderModal .modal-dialog .modal-content').css({
            'padding': '0px 0px',
        });
        $('#builderModal .modal-dialog').addClass('login-styles');
        $('#builderModal .modal-header').addClass('login-styles-modal-header');
        $('#builderModal .modal-header .close').css({
            'display': 'inline-flex',
            'align-items': 'center',
            'justify-content': 'center',
            'width': '32px',
            'height': '32px',
            'border-radius': '50%',
            'background-color': '#e7eaec',
            'border': '0',
            'font-size': '1.8rem',
            'font-weight': 'lighter',
            'cursor': 'pointer',
            'color': 'black',
            'padding': '0px',
            'z-index': '1200',

        });
        $('#builderModal .modal-header').css('border', '0px');
        $('.PopUpContent').css('height', 'auto');
        $('#builderModal .default-popup').show();
        $('#builderModal .right-popup').hide();
    } else if (size === 'fit') {
        $('#builderModal .modal-dialog').addClass('modal-size-small');
        $('.default-popup').addClass('modal-dialog-centered');

        const screenWidth = $(window).width(); // Get screen width
       // const scaleFactor = screenWidth < 530 ? Math.min((screenWidth / 530 + 0.15), 1) : 1;  // Calculate scale factor if screen width is less than 530px
        const scaleFactor = 1;
        const calculatedHeight = `min(820px, max(85vh, calc(var(--vh, 1vh) * ${100 / scaleFactor})))`;



        // Set full screen size for mobile, but shrink content if needed
        $('#builderModal .modal-dialog').css({
            'min-width': '530px',
            'max-width': screenWidth < 530 ? `${screenWidth}px` : '530px', // Use JS to handle screen width logic
            'transform': `scale(${scaleFactor})`,
            'max-height': '100vh', // Prevent exceeding viewport height
            'border-radius': '20px',
            'display': 'flex',
            'height': calculatedHeight, // Use pre-calculated height for CSS,
            'flex-direction': 'column',
            'justify-content': 'center', // Vertically center the modal content
        });


        $('#builderModal .modal-content').css({
            'height': 'auto',
            'max-height': '100%', // Ensure it doesn't exceed the modal height
            'display': 'flex',
            'flex-direction': 'column',
            'justify-content': 'center',
            'transform-origin': 'top', // Scale from the top
            'flex-grow': '1', // Allow modal content to grow/shrink with viewport
        });

        $('#builderModal .modal-dialog').addClass('login-styles');
        $('#builderModal .modal-header').addClass('login-styles-modal-header');

        // Apply transform scale if content exceeds height
        const contentHeight = $('#builderModal .modal-content').outerHeight();
        const availableHeight = $(window).height();

        if (contentHeight > availableHeight) {
            const scale = availableHeight / contentHeight;
            $('#builderModal .modal-content').css({
                'transform': `scale(${scale})`, // Shrink content
                'transform-origin': 'top center', // Shrink from the center
            });
        } else {
            $('#builderModal .modal-content').css({
                'transform': 'scale(1)', // No scaling if it fits
            });
        }

        $('#builderModal .modal-header').css({
            'border-bottom': 'none',
        });

        $('#builderModal .modal-body').css({
            'padding': '0px 20px',
            'flex-grow': '1', // Allow the body to grow/shrink based on content
        });

        $('#builderModal .modal-header .close').css({
            'display': 'inline-flex',
            'align-items': 'center',
            'justify-content': 'center',
            'width': '32px',
            'height': '32px',
            'border-radius': '50%',
            'background-color': '#e7eaec',
            'border': '0',
            'font-size': '1.8rem',
            'font-weight': 'lighter',
            'cursor': 'pointer',
            'color': 'black',
            'padding': '0px',
            'z-index': '1200',
        });



        $('#builderModal .modal-header #goback').css({
            'display': 'inline-flex',
            'align-items': 'center',
            'justify-content': 'center',
            'width': '32px',
            'height': '32px',
            'border-radius': '50%',
            'background-color': '#e7eaec',
            'border': '0',
            'font-size': '1.8rem',
            'font-weight': 'lighter',
            'cursor': 'pointer',
            'color': 'black',
            'padding': '0px',
            'z-index': '1200',
        });

        $('#builderModal .modal-header').css('border', '0px');
        $('.PopUpContent').css('height', 'auto');
        $('#builderModal .default-popup').show();
        $('#builderModal .right-popup').hide();
    } else {
        $('#builderModal .modal-dialog').addClass('modal-size-default');
        $('#builderModal .modal-dialog').css('max-width', 'none');
        $('.PopUpContent').css('height', '481px');
        $('#builderModal .default-popup').show();
        $('#builderModal .right-popup').hide();
    }

    // Set up the close button event
    $('#popupclosebutton').click(function (e) {
        e.stopImmediatePropagation();
        cancelActionInCaseOfLoginClosed();
        if (activePopup) {
            activePopup.hide();
        }
    });

    // Set this instance as the active popup
    activePopup = this;

    $('#popupTitle').html(title);
};

// Add methods to the PopUp prototype
PopUp.prototype = {
    close: function () {
        console.log('close called');
        this.hide(); // Use the hide method for closing
    },
    show: function () {
        showModalBackDrop(true);
        $('#builderModal').addClass('show');
        $('#builderModal').show();

        // Check if size is 'midsize' and initialize GLightbox
        if ($('#builderModal .modal-dialog').hasClass('modal-size-small')) {
            if (typeof GLightbox !== 'undefined') {
                GLightbox({
                    touchNavigation: true,
                    loop: true,
                    zoomable: true,
                    openEffect: 'zoom',
                    closeEffect: 'fade',
                    slideEffect: 'fade',
                });
            }
        }
    },
    hide: function () {
        const popupVisible = $('#builderModal').is(":visible");
        if (popupVisible) {
            console.log(`Hidepopup--${this.name}`);
            this.detachContent(this.sourceId); // Use the sourceId to detach content
            $('#builderModal').hide();
            navigate(getBasePath(window.location.href));
        }
        $('#builderModal').removeClass('show');
        console.log ('Builder hidding modal popup');
        hideModalBackDrop();
        scrollToTopWhenWindowScrolls(); // Revert the scroll back for mobile screens
    },
    attachContent: function (sourceId) {
        // Attach the content from the source to the target
        $(sourceId).children().appendTo('.PopUpContent');
    },
    detachContent: function (sourceId) {
        // Detach the content from the PopUpContent and append it back to the source
        $('.PopUpContent').children().detach().appendTo(sourceId);
    },
    load: function (url, callback = function () { }) {
        var thisPopup = this;

        $.ajax({
            url: url,
            type: 'GET',
        }).done(function (resp) {
            thisPopup.remove();
            thisPopup.loadHtml(resp);
            callback();
        });
    },
    remove: function () {
        $('.PopUpContent').html('');
    },
    loadHtml: function (html) {
        this.remove();
        $('.PopUpContent').html(html);
        this.show();

        // Check if size is 'midsize' and initialize GLightbox
        if ($('#builderModal .modal-dialog').hasClass('modal-size-small')) {
            if (typeof GLightbox !== 'undefined') {
                GLightbox({
                    touchNavigation: true,
                    loop: true,
                    zoomable: true,
                    openEffect: 'zoom',
                    closeEffect: 'fade',
                    slideEffect: 'fade',
                });
            }
        }
    },
    loadHtmlXright: function () {
        this.remove();
        this.getContainer('xright');
    },
    getContainer: function (position = 'default') {
        if (position === 'xright') {
            return $('.right-box').html();
        } else {
            return '';
        }
    }
};

export { PopUp };
